import * as yup from 'yup';

export const LcAvcSchema = yup.object().shape({
  //  Dados Gerais
  num_registro_avc: yup
  .number()
  .typeError('Campo obrigatório. Mínimo 5 dígitos.')
  .required('Campo obrigatório'),
  sexo_avc: yup.string().nullable(true),
  dn_avc: yup.string().nullable(true),
  convenio_avc: yup.string().nullable(true),

  // Dados da doença
  classificacao_avc: yup.string().nullable(true),
  ex_imagem_avc: yup.string().nullable(true),
  sintomas_data_avc: yup.string().nullable(true),
  sintomas_hora_avc: yup.string().nullable(true),
  emergencia_data_avc: yup.string().nullable(true),
  emergencia_hora_avc: yup.string().nullable(true),
  nihss_resultado_avc: yup.string().nullable(true),

  // Local de atendimento do paciente durante a internação
  local_avc_uni_vasc: yup.string().nullable(true),
  local_avc_emer_geral: yup.string().nullable(true),
  local_avc_uti_neuro: yup.string().nullable(true),
  local_avc_uti_geral: yup.string().nullable(true),
  local_avc_uni_avc: yup.string().nullable(true),
  local_avc_enf_geral: yup.string().nullable(true),

  // Tratamento de reperfusão
  reperfusao_avc_tiv: yup.string().nullable(true),
  reperfusao_avc_tia: yup.string().nullable(true),
  reperfusao_avc_trombec: yup.string().nullable(true),

  // Tratamento
  trombolise_data_avc: yup.string().nullable(true),
  trombolise_hora_avc: yup.string().nullable(true),
  trombectomia_data_avc: yup.string().nullable(true),
  trombectomia_hora_avc: yup.string().nullable(true),
  fa_avc: yup.string().nullable(true),
  disfagia_avc: yup.string().nullable(true),
  paliativos_avc: yup.string().nullable(true),

  // Dados da saída
  antiagregante_avc: yup.string().nullable(true),
  anticoagulante_avc: yup.string().nullable(true),
  covid_avc: yup.string().nullable(true),
  saida_motivo_avc: yup.string().nullable(true),
  obito_causa_avc: yup.string().nullable(true),
  saida_data_avc: yup.string().nullable(true),
  saida_hora_avc: yup.string().nullable(true),

  // Seguimento
  rankin_avc: yup.string().nullable(true),
});
